import { SurveyHeader } from '@components/shared/survey-header.component';
import { cn } from '@lib/utils';

type AssessmentSectionOverviewSection = {
  answered: number;
  id: string;
  title: string;
  total: number;
};

type AssessmentSectionOverviewProps = {
  chapterIndex: number;
  onSectionSelect: (sectionId: string) => void;
  sections: AssessmentSectionOverviewSection[];
  title: string;
};

export const AssessmentSectionOverview: React.FC<AssessmentSectionOverviewProps> = (props) => {
  const { chapterIndex, onSectionSelect, sections, title } = props;

  const answeredQuestions = sections.reduce((accumulator, section) => accumulator + section.answered, 0);
  const totalQuestions = sections.reduce((accumulator, section) => accumulator + section.total, 0);
  const progress = totalQuestions === 0 ? 1 : answeredQuestions / totalQuestions;

  return (
    <div className="@container/survey-sections h-full w-full overflow-y-auto p-[24px]">
      <SurveyHeader
        header={`Part ${chapterIndex + 1}`}
        progress={progress}
        title={title}
        value={chapterIndex + 1}
      />
      <div className="grid w-full grid-cols-1 gap-4 py-4 @min-[50rem]/survey-sections:grid-cols-2 @min-[72rem]/survey-sections:grid-cols-3">
        {sections.map((section, index) => {
          const allAnswered = section.answered === section.total && section.total > 0;

          return (
            <div
              className="flex h-[170px] cursor-pointer flex-col rounded-lg bg-white px-[20px] py-[18px] shadow hover:bg-linear-to-b hover:from-indigo-300 hover:bg-gray-200"
              key={section.id}
              onClick={() => onSectionSelect(section.id)}
            >
              <div className="flex items-center gap-2">
                <div className="text-[16px] font-semibold text-[#3d2eff]">Section {index + 1}</div>
              </div>
              <div className="line-clamp-2 pt-[10px] text-lg font-semibold text-[#1f1c1a]">{section.title}</div>
              <div
                className={cn('mt-auto text-[18.5px] font-normal', allAnswered ? 'text-[#00A76B]' : 'text-[#1F1C1AB2]')}
              >
                {`${section.answered} of ${section.total} answered`}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
